import { scan } from "react-scan";
import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter, createRoutesFromElements, Route } from "react-router";

import "./index.css";
import App from "./App";
import AdminHomeView from "./views/admin/AdminHomeView";
import EPGAdminHomeView from "./views/admin/epg/EPGAdminHomeView";
import EPGGridView from "./views/admin/epg/EPGGridView";
import EPGDetailsView from "./views/admin/epg/EPGDetailsView";
import EPGIngestView from "./views/admin/epg/EpgIngestView";
import VODAdminHomeView from "./views/admin/vod/VODAdminHomeView";
import VODAssetView from "./views/admin/vod/VODAssetView";

import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import duration from "dayjs/plugin/duration";
import VODContentGroupView from "./views/admin/vod/VODContentGroupView";
import VODContentView from "./views/admin/vod/VODContentView";
import VODFpbSummaryListingView from "./views/admin/vod/components/assets/VODFpbSummaryListingView";

dayjs.extend(isBetween);
dayjs.extend(duration);

scan({
    enabled: (process.env.NODE_ENV === "development" && process.env.REACT_SCAN_ENABLED === "true"),
});

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/dashboard" element={ <App /> }>
            <Route index element={<AdminHomeView />} />
            <Route path="/dashboard/epg" element={<EPGAdminHomeView />} />
            <Route path="/dashboard/epg/home" element={<EPGAdminHomeView />} />
            <Route path="/dashboard/epg/grid" element={<EPGGridView />} />
            <Route path="/dashboard/epg/ingest" element={<EPGIngestView />} />
            <Route path="/dashboard/epg/grid/:id" element={<EPGDetailsView />} />
            <Route path="/dashboard/vod/home" element={<VODAdminHomeView />} />
            <Route path="/dashboard/vod/fpb-summary" element={<VODFpbSummaryListingView />} />
            <Route path="/dashboard/vod/assets/:assetType" element={<VODAssetView />} />
            <Route path="/dashboard/vod/assets/series-content-group/:seriesAmsProviderId/:seriesBaseContentGroupId"
                   element={<VODContentGroupView />}
            />
            <Route path={
                       "/dashboard/vod/assets/series-content-group/:seriesAmsProviderId/:seriesBaseContentGroupId" +
                       "/season-content-group/:seasonAmsProviderId/:seasonBaseContentGroupId"
                   }
                   element={<VODContentGroupView />}
            />
            <Route path={
                       "/dashboard/vod/assets/series-content-group/:seriesAmsProviderId/:seriesBaseContentGroupId" +
                       "/season-content-group/:seasonAmsProviderId/:seasonBaseContentGroupId" +
                       "/content/:amsProviderId/:baseContentId"
                   }
                   element={<VODContentView />}
            />
            <Route path="/dashboard/vod/assets/standalone-content/:amsProviderId/:baseContentId" element={<VODContentView />} />
        </Route>
    )
);

const container = document.getElementById("react");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

